import './DirectIntegrationTable.scss';
import { Fragment, useEffect, useRef, useState } from 'react';
import {
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Tooltip,
  FormHelperText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
  TextField,
  InputAdornment
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
// import DownloadIcon from '../../assets/images/capabilities/download.svg';
// import InfoIcon from '../../assets/images/capabilities/information.svg';
import CloseIcon from '../../assets/images/capabilities/close.svg';
import ChevronDown from '../../assets/images/capabilities/chevron.png';
import ArrowIcon from '../../assets/images/capabilities/arrow.svg';
import SearchIcon from '../../assets/images/capabilities/search.svg';
import DownArrow from '../../assets/images/capabilities/chevronDown.svg';
import SupportIcon from '../../assets/images/capabilities/supported.svg';
import NotSupportedIcon from '../../assets/images/capabilities/notSupported.svg';
import InProgressIcon from '../../assets/images/capabilities/inProgress.svg';
import LimitedIcon from '../../assets/images/capabilities/limited.svg';
import PartnerSelection from './PartnerSelection';
 
const getFullImageLink = (image: string) => {
  const env = process.env["REACT_APP_ENV_LOADED"];
  let url = `https://content-ndc-portal.aircanada.com`; //default to prod
  if (env === "DEV" || env === "INT" || env === "CRT") {
    url = `https://content-ndc-portal-int.aircanada.com`;
  } else if (env === "BAT" || env === "PREPROD") {
    url = `https://content-ndc-portal-bat.aircanada.com`;
  }
  return url + image;
};
 
const DirectIntegrationTable = ({ compPartner }) => {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  // const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(max-width:1050px)');
  //const breakpointCheck = useMediaQuery('(max-width:1200px)');
  const selectRefs = [
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null)
  ];

  const textFieldRefs = [
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null),
    useRef<HTMLInputElement>(null)
  ];

  const firstMenuItemRefs = [
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null),
    useRef<HTMLLIElement>(null)
  ];
  const column = t('capabilities_direct_integration_1', {
    returnObjects: true
  });
 
  const capabilityData = t('capabilities_function_functionsandfeaturestable', {
    returnObjects: true,
    defaultValue: { en: { functionalities: [] } }
  });
 
  const cat = t('capabilities_table_partners', { returnObjects: true ,defaultValue: [] as any});
 
  const catArray = Array.isArray(cat) ? cat : [];
  // console.log(cat)
 
  let capabilityColumns = language === 'fr' ? capabilityData['fr'].functionalities : capabilityData['en'].functionalities;
 
  const columnTable = column[0].columns.split(',');
  const section = capabilityColumns as any[];
  const statusTranslations = column[0].status;
 
  const containerRef = useRef<HTMLTableElement>(null);
  // const [sectionCount, setSectionCount] = useState(0);
  // useEffect(() => {
  //   if (section.length) {
  //     setSectionCount(section.length);
  //   }
  // }, [section]);
  const [activedropdown, setActiveDropdown] = useState<number | null>(null);
  const [openDropdown, setOpenDropdown] = useState([false, false, false]);
  const [isInfoBoxOpen, setIsInfoBoxOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [announcementMessage, setAnnouncementMessage] = useState<string | null>(
    null
  );
  const [expandedFunctionalities, setExpandedFunctionalities] = useState(() => {
    const state = {};
    if (Array.isArray(section)) {
      section.forEach((functionality, index) => {
        state[index] = true;
      });
    }
    return state;
  });
 
  const [expandedFeatures, setExpandedFeatures] = useState(() => {
    const state = {};
    if (Array.isArray(section)) {
      section.forEach((functionality, funcIndex) => {
        if (functionality?.features && Array.isArray(functionality.features)) {
          functionality.features.forEach((feature, featureIndex) => {
            state[`${funcIndex}-${featureIndex}`] = false;
          });
        }
      });
    }
    return state;
  });

  const [selectedPartner, setSelectedPartner] = useState({});
  const [resetPartner, setResetPartner] = useState<string | null>(null);
  const [selectedPartners, setSelectedPartners] = useState<any>([
    {
      partnerURL: '',
      partnerLogo: ''
    },
    {
      partnerURL: '',
      partnerLogo: ''
    },
    {
      partnerURL: '',
      partnerLogo: ''
    }
  ]);
 
  // const additionalInformation = data[0].footer[0].entries;
  //const columns = data[0].columns.split(',');
  //const quickLinks = data[0].footer[1];
  //const sections = data[0].sections;
 
  const announceTableUpdate = () => {
    setAnnouncementMessage(null);
    setTimeout(() => {
      setAnnouncementMessage(
        'Partners capability comparison table has been updated. Use your screen reader’s table navigation commands to explore the updated content.'
      );
    }, 1000);
  };
 
  const calculateAverageStatus = (features, selectedPartner, columnIndex) => {
    const partnerName =
      selectedPartners[columnIndex].partnerLogo ?? selectedPartner[columnIndex];
 
    if (!partnerName) return null;
 
    const statuses = features.flatMap((feature) => {
      const featureStatuses = feature.partners?.[partnerName]
        ? [feature.partners[partnerName]]
        : [];
 
      const subFeatureStatuses = feature.subFeatures
        ? feature.subFeatures
          .map((subFeature) => subFeature.partners?.[partnerName])
          .filter((status) => status !== undefined)
        : [];
      return [...featureStatuses, ...subFeatureStatuses];
    });
 
    if (statuses.length === 0) return null;
 
    const allSupported = statuses.every(
      (status) => status === statusTranslations.supported
    );
    if (allSupported) {
      return statusTranslations.supported;
    }
 
    const allNotSupported = statuses.every(
      (status) => status === statusTranslations.notSupported
    );
    if (allNotSupported) return statusTranslations.notSupported;
 
    const hasInProgress = statuses.some(
      (status) =>
        status === statusTranslations.Limited ||
        status === statusTranslations.notSupported ||
        status === statusTranslations.inProgress
    );
    if (hasInProgress) {
      return statusTranslations.Limited;
    }
    return null;
  };
 
  const handlePartnerChange = (event, columnIndex) => {
    const partnerId = event.target.value;
 
    const partner = catArray.find(
      (p) => p.id === parseInt(partnerId)
    );
 
    setSelectedPartner((prevState) => ({
      ...prevState,
      [columnIndex]: partner?.title || null
    }));
 
    setSelectedPartners((prevState) => {
      const updated = [...prevState];
      updated[columnIndex].partnerLogo = partner?.title || '';
      updated[columnIndex].partnerURL = partner?.title || '';
      return updated;
    });
    setActiveDropdown(columnIndex);
    announceTableUpdate();
  };
 
  const getFilteredPartners = (columnIndex, searchInput = '') => {
    const selectedValues = selectedPartners.map(
      (partner) => partner.partnerLogo
    );
 
    const partners = catArray
      .filter(
        (partner) =>
          !selectedValues.includes(partner.title) ||
          partner.title === selectedPartners[columnIndex].partnerLogo
      )
      .sort((a, b) => a.title.localeCompare(b.title));
 
    if (searchInput) {
      return partners.filter((partner) =>
        partner.title
          .toLowerCase()
          .includes(searchInput.trim().toLowerCase())
      );
    } else {
      return partners;
    }
  };
 
  const handlePartnerSelection = (partner: any, index: number) => {
    setSelectedPartners((prev) => {
      const updated = [...prev];
      if (partner === null) {
        updated[index].partnerURL = '';
        updated[index].partnerLogo = '';
      } else {
        updated[index].partnerURL = partner.title;
        updated[index].partnerLogo = partner.title;
      }
      return updated;
    });
    announceTableUpdate();
    //setResetPartner(null);
  };
 
  const getStatusTooltip = (statusKey) => {
    if (language === 'fr' && column[0].statusTooltip) {
      // Find the key in status that matches the value, then get the tooltip
      const statusObj = column[0].status;
      const tooltipObj = column[0].statusTooltip;  
      // Find the key in statusObj whose value matches statusKey
      const foundKey = Object.keys(statusObj).find(key => statusObj[key] === statusKey);
      if (foundKey && tooltipObj[foundKey]) {
        return tooltipObj[foundKey];
      }
    }
    return statusKey;
  };
   
 
  const getStatusIcon = (status) => {
    const tooltipStyles = {
      tooltip: {
        backgroundColor: '#FFFFFF',
        color: '#000000',
        borderRadius: '16px',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0px',
        verticalAlignment: 'middle',
        //top: '5px',
        textAlign: 'center',
        padding: '10px',
        boxShadow: '0px 0px 15px 0px rgba(0,0,0,0.15)'
      },
      arrow: {
        color: '#FFFFFF'
      }
    };
    switch (status) {
      case statusTranslations.supported:
        return (
          <Tooltip
            title={getStatusTooltip(statusTranslations.supported)}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={SupportIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Supported</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.notSupported:
        return (
          <Tooltip
            title={getStatusTooltip(statusTranslations.notSupported)}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={NotSupportedIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Not Supported</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.inProgress:
        return (
          <Tooltip
            title={getStatusTooltip(statusTranslations.inProgress)}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={InProgressIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">In progress</span>
            </span>
          </Tooltip>
        );
      case statusTranslations.Limited:
        return (
          <Tooltip
            title={getStatusTooltip(statusTranslations.Limited)}
            arrow
            componentsProps={{
              tooltip: { sx: tooltipStyles.tooltip },
              arrow: { sx: tooltipStyles.arrow }
            }}
          >
            <span
              tabIndex={-1}
            >
              <img
                src={LimitedIcon}
                alt=""
                aria-hidden="true"
                className="status-icon"
              />
              <span className="sr-only">Partial/Limited</span>
            </span>
          </Tooltip>
        );
      default:
        return null;
    }
  };
 
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState<number | null>(null);
 
  const handleDropdownToggle = (index: number, isOpen: boolean) => {
    setOpenDropdown((prev) => {
      const newState = [...prev];
      newState[index] = isOpen;
      return newState;
    });
    const headerElement = headerRef.current;
    const theadRows = headerElement?.querySelectorAll('tr');
    const partnerSelectRow = theadRows && theadRows.length > 1 ? theadRows[1] as HTMLElement : null;
    const headerTabElement = headerTabRef.current;
 
    if (isOpen) {
      setDropdownOpenIndex(index);
      if (partnerSelectRow?.style.position !== 'fixed' && headerTabElement?.style.position !== 'fixed') {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.overflow = 'hidden';
        document.body.dataset.scrollY = scrollY.toString();
      }
      setTimeout(() => {
        textFieldRefs[index].current?.focus();
      }, 300);
 
      if (activedropdown === index) {
        setSelectedPartner({});
        setActiveDropdown(null);
      } else {
        setSelectedPartner({});
        setActiveDropdown(index);
      }
    } else {
      if (partnerSelectRow?.style.position !== 'fixed' && headerTabElement?.style.position !== 'fixed') {
        const scrollY = document.body.dataset.scrollY || '0';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.overflow = '';
        window.scrollTo(0, parseInt(scrollY));
      }
      setSearchTerm('');
      setActiveDropdown(null);
      setDropdownOpenIndex(null);
    }
  };
 
  // useEffect(() => {
  //   const handleClick = (event: MouseEvent) => {
  //     const target = event.target as HTMLElement;
  //     if (
  //       !target.closest('.native-select-root') &&
  //       !target.closest('.MuiSelect-root')
  //     ) {
  //       setSelectedPartner({});
  //     }
  //   };
  //   const tableElement = containerRef.current;
  //   if (tableElement) {
  //     tableElement.addEventListener('click', handleClick);
  //   }
  //   return () => {
  //     if (tableElement) {
  //       tableElement.removeEventListener('click', handleClick);
  //     }
  //   };
  // }, []);
 
  // const toggleInfoBox = () => {
  //   setIsInfoBoxOpen(true);
  // };
 
  const toggleCloseInfoBox = () => {
    setIsInfoBoxOpen((prevState) => !prevState);
  };
 
  const toggleExpandCollapse = () => {
    setIsExpanded((prevState) => !prevState);
 
    // Update all functionalities to expand/collapse
    const newFunctionalityState = {};
    const newFeatureState = {};
   
    if (Array.isArray(section)) {
      section.forEach((functionality, funcIndex) => {
        newFunctionalityState[funcIndex] = !isExpanded;
       
        if (functionality?.features && Array.isArray(functionality.features)) {
          functionality.features.forEach((feature, featureIndex) => {
            newFeatureState[`${funcIndex}-${featureIndex}`] = !isExpanded;
          });
        }
      });
    }
   
    setExpandedFunctionalities(newFunctionalityState);
    setExpandedFeatures(newFeatureState);
  };
 
  const handleFunctionalityToggle = (functionalityIndex: number) => {
    setExpandedFunctionalities((prevState) => ({
      ...prevState,
      [functionalityIndex]: !prevState[functionalityIndex]
    }));
  };
 
  const handleFeatureToggle = (functionalityIndex: number, featureIndex: number) => {
    const key = `${functionalityIndex}-${featureIndex}`;
    setExpandedFeatures((prevState) => ({
      ...prevState,
      [key]: !prevState[key]
    }));
  };
 
  const handleSelect = (index) => {
    const partner = catArray.find(
      (item) => item.title === selectedPartners[index].partnerLogo
    );
    return partner ? partner.id.toString() : '';
  };
 
  // Remove this entire useEffect block:
  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        !target.closest('.native-select-root') &&
        !target.closest('.MuiSelect-root')
      ) {
        setSelectedPartner({});
      }
    };
    const tableElement = containerRef.current;
    if (tableElement) {
      tableElement.addEventListener('click', handleClick);
    }
    return () => {
      if (tableElement) {
        tableElement.removeEventListener('click', handleClick);
      }
    };
  }, []);
 
  const headerRef = useRef<HTMLTableSectionElement>(null);
  const headerTabRef = useRef<HTMLTableSectionElement>(null);
 
  const calculateFinalTabHeight = () => {
    const getHeightAndMargin = (selector, marginType, isOffset) => {
      const element = document.querySelector(selector);
      if (!element) return 0;
 
      const height = element.getBoundingClientRect().height || 0;
      return height;
    };
    const headerHeight = getHeightAndMargin('.logo', 'marginTop', 'true');
    const discoverHeaderHeight = getHeightAndMargin('.discover-header', 'marginTop', 'true');
    const tabsContainerHeight = getHeightAndMargin('.connectionTabsContainer', 'marginTop', 'true');
    const selectDropdownHeight = getHeightAndMargin('.selectDropdown', 'marginTop', 'true');
    const contentSpacingHeight = getHeightAndMargin('.content-spacing', 'marginBottom', 'true');
 
    const finalHeight =
      headerHeight +
      selectDropdownHeight +
      tabsContainerHeight +
      discoverHeaderHeight +
      contentSpacingHeight +
      60;
 
    return finalHeight;
 
  }
 
  const calculateFinalHeight = () => {
    const getHeightAndMargin = (selector, marginType, isOffset) => {
      const element = document.querySelector(selector);
      if (!element) return 0;
 
      const offsetHeight = isOffset ? element.offsetHeight || 0 : 0;
      return offsetHeight;
    };
 
    const headerHeight = getHeightAndMargin('.header', 'marginTop', 'true');
    const menuBarHeight = getHeightAndMargin('.menuBarContainerDesktop', 'marginTop', 'true');
    const discoverHeaderHeight = getHeightAndMargin('.discover-header', 'marginTop', 'true');
    const tabsContainerHeight = getHeightAndMargin('.connectionTabsContainer', 'marginTop', 'true');
    const bodyContainerHeight = getHeightAndMargin('.partnerSelectionContainer', 'marginBottom', 'true');
    const contentSpacingHeight = getHeightAndMargin('.content-spacing', 'marginBottom', 'true');
 
    const finalHeight =
      headerHeight +
      menuBarHeight +
      discoverHeaderHeight +
      tabsContainerHeight +
      bodyContainerHeight +
      contentSpacingHeight;
 
    return finalHeight;
  };
 
  useEffect(() => {
    const handleScroll = () => {
      if (!isTablet) {
        return;
      }
      const headerTabElement = headerTabRef.current;
      const appTabHeader = document.querySelector('.header') as HTMLElement;
      const collapseExpandElement = document.querySelector('.collapse-expand') as HTMLElement;
      const menuBar = document.querySelector('.menuBarContainerDesktop') as HTMLElement;
 
      const finalTabHeight = calculateFinalTabHeight();
      const tableTabElement = containerRef.current;
 
      const appTabHeaderHeight = (appTabHeader?.offsetHeight || 0) + (menuBar?.offsetHeight || 0);
      const theadTabHeight = headerTabElement?.getBoundingClientRect().height || 0;
      const collapseTabHeight = collapseExpandElement?.getBoundingClientRect().height || 0;
 
      // Create placeholder elements if they don't exist
      let headerPlaceholder = document.querySelector('.header-placeholder') as HTMLElement;
      let collapsePlaceholder = document.querySelector('.collapse-placeholder') as HTMLElement;
 
      if (!headerPlaceholder && headerTabElement) {
        headerPlaceholder = document.createElement('div');
        headerPlaceholder.className = 'header-placeholder';
        headerPlaceholder.style.height = `${theadTabHeight}px`;
        headerPlaceholder.style.width = '100%';
 
        tableTabElement?.insertBefore(headerPlaceholder, tableTabElement?.firstChild);
      }
      if (!collapsePlaceholder && collapseExpandElement) {
        collapsePlaceholder = document.createElement('div');
        collapsePlaceholder.className = 'collapse-placeholder';
        collapsePlaceholder.style.height = `${collapseExpandElement.getBoundingClientRect().height}px`;
        collapsePlaceholder.style.width = '100%';
        tableTabElement?.insertBefore(collapsePlaceholder, headerPlaceholder.nextSibling);
      }
      //condition for fixing header and second row
      if (headerTabElement && collapseExpandElement && tableTabElement) {
 
        const scrollY = window.scrollY;
        const tableTabBottom = tableTabElement?.getBoundingClientRect().bottom + scrollY;
 
        if (scrollY > finalTabHeight && scrollY + appTabHeaderHeight + theadTabHeight + collapseTabHeight < tableTabBottom - theadTabHeight + appTabHeaderHeight + collapseTabHeight) {
 
          const originalWidth = headerTabElement.getBoundingClientRect().width || 0;
          const collapseWidth = collapseExpandElement.getBoundingClientRect().width || 0;
 
          // Fix header
          headerTabElement.style.position = 'fixed';
          headerTabElement.style.top = `${appTabHeaderHeight}px`;
          headerTabElement.style.zIndex = '1';
          headerTabElement.style.width = `${originalWidth}px`;
          headerTabElement.style.backgroundColor = '#ffffff';
 
 
          // Fix collapse-expand element
          collapseExpandElement.style.position = 'fixed';
          collapseExpandElement.style.top = `${appTabHeaderHeight + theadTabHeight}px`;
          collapseExpandElement.style.zIndex = '1';
          collapseExpandElement.style.width = `${collapseWidth}px`;
 
 
          // Show placeholders
          if (headerPlaceholder) headerPlaceholder.style.display = 'block';
          if (collapsePlaceholder) collapsePlaceholder.style.display = 'block';
 
          if (!isHeaderFixed) {
            setIsHeaderFixed(true);
            //setHeaderTransition(false);
          }
        } else {
          headerTabElement.style.position = 'static';
          collapseExpandElement.style.position = 'static';
 
 
 
          // Hide placeholders instead of removing them
          if (headerPlaceholder) headerPlaceholder.style.display = 'none';
          if (collapsePlaceholder) collapsePlaceholder.style.display = 'none';
 
          if (isHeaderFixed) {
            setIsHeaderFixed(false);
 
            if (dropdownOpenIndex !== null) {
              handleDropdownToggle(dropdownOpenIndex, true);
            }
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      // Cleanup placeholders
      const headerPlaceholder = document.querySelector('.header-placeholder') as HTMLElement;
      const collapsePlaceholder = document.querySelector('.collapse-placeholder') as HTMLElement;
      if (headerPlaceholder) headerPlaceholder.remove();
      if (collapsePlaceholder) collapsePlaceholder.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderFixed, dropdownOpenIndex]);
 
  useEffect(() => {
    const handleScroll = () => {
      const headerElement = headerRef.current;
      const tableElement = containerRef.current;
      if (!headerElement || !tableElement) return;
 
      // Select the second tr in thead (partner select row)
      const theadRows = headerElement?.querySelectorAll('tr');
      const partnerSelectRow = theadRows && theadRows.length > 1 ? theadRows[1] as HTMLElement : null;
      if (!partnerSelectRow) return;
 
      // Select the first tr in tbody (collapse/expand row)
      const tbodyRows = tableElement.querySelectorAll('tbody tr');
      const collapseExpandRow = tbodyRows[0] as HTMLElement;
 
      // For border radius and borderTop
      const firstThElement = partnerSelectRow?.querySelector('td,th') as HTMLElement;
      const lastThElement = partnerSelectRow?.querySelector('td:last-child,th:last-child') as HTMLElement;
 
      // Get column widths from the partner select row (second thead row)
      const columnWidths = Array.from(partnerSelectRow?.children || []).map(
        (cell: any) => cell.getBoundingClientRect().width
      );
 
      const finalHeight = calculateFinalHeight();
      const appHeader = document.querySelector('.header') as HTMLElement;
      const menuBar = document.querySelector('.menuBarContainerDesktop') as HTMLElement;
      const appHeaderHeight = (appHeader?.offsetHeight || 0) + (menuBar?.offsetHeight || 0);
 
      if (partnerSelectRow && collapseExpandRow) {
        const scrollY = window.scrollY;
        const tableBottom = tableElement.getBoundingClientRect().bottom + window.scrollY;
        const partnerSelectRowHeight = partnerSelectRow.offsetHeight || 0;
 
        // When to fix
        if (
          scrollY > finalHeight &&
          scrollY + appHeaderHeight + partnerSelectRowHeight <
          tableBottom - partnerSelectRowHeight
        ) {
          // Set widths for sticky columns
          Array.from(partnerSelectRow.children).forEach((cell: any, idx) => {
            cell.style.width = `${columnWidths[idx]}px`;
            cell.style.maxWidth = `${columnWidths[idx]}px`;
            cell.style.minWidth = `${columnWidths[idx]}px`;
            cell.style.overflow = 'hidden';
            cell.style.textOverflow = 'ellipsis';
            cell.style.whiteSpace = 'nowrap';
          });
          Array.from(collapseExpandRow.children).forEach((cell: any, idx) => {
            cell.style.width = `${columnWidths[idx]}px`;
            cell.style.maxWidth = `${columnWidths[idx]}px`;
            cell.style.minWidth = `${columnWidths[idx]}px`;
          });
 
          // Fix partner select row (second thead row)
          partnerSelectRow.style.position = 'fixed';
          partnerSelectRow.style.top = `${appHeaderHeight}px`;
          partnerSelectRow.style.zIndex = '1';
          partnerSelectRow.style.backgroundColor = '#ffffff';
 
          // Add requested styles
          partnerSelectRow.style.borderTop = '0.5px solid #c9cacc';
          if (firstThElement) firstThElement.style.borderRadius = '0';
          if (lastThElement) lastThElement.style.borderRadius = '0';
 
          // Fix collapse/expand row just below partner select row
          collapseExpandRow.style.position = 'fixed';
          collapseExpandRow.style.top = `${appHeaderHeight + partnerSelectRowHeight}px`;
          collapseExpandRow.style.zIndex = '1';
          collapseExpandRow.style.backgroundColor = '#ffffff';
 
          if (!isHeaderFixed) setIsHeaderFixed(true);
        } else {
          // Reset styles
          partnerSelectRow.style.position = 'static';
          partnerSelectRow.style.top = '';
          partnerSelectRow.style.zIndex = '';
          partnerSelectRow.style.backgroundColor = '';
          partnerSelectRow.style.width = '';
          Array.from(partnerSelectRow.children).forEach((cell: any) => {
            cell.style.width = '';
          });
 
          collapseExpandRow.style.position = 'static';
          collapseExpandRow.style.top = '';
          collapseExpandRow.style.zIndex = '';
          collapseExpandRow.style.backgroundColor = '';
          collapseExpandRow.style.width = '';
          Array.from(collapseExpandRow.children).forEach((cell: any) => {
            cell.style.width = '';
          });
 
          // Reset requested styles
          partnerSelectRow.style.borderTop = '';
          if (firstThElement) firstThElement.style.borderRadius = '';
          if (lastThElement) lastThElement.style.borderRadius = '';
 
          if (isHeaderFixed) {
            setIsHeaderFixed(false);
            if (dropdownOpenIndex !== null) {
              handleDropdownToggle(dropdownOpenIndex, true);
            }
          }
        }
      }
    };
 
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHeaderFixed, dropdownOpenIndex]);
 
  const [highlightedIndex, setHighlightedIndex] = useState<number[]>([-1, -1, -1]);
 
  // Enhanced keyboard handler for W3C compliance
  const handleSelectKeyDown = (e: React.KeyboardEvent, index: number) => {
    const filteredPartners = getFilteredPartners(index, searchTerm);
    const isOpen = openDropdown[index];
 
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        if (e.altKey || !isOpen) {
          // Alt + Down Arrow opens the dropdown (W3C requirement)
          handleDropdownToggle(index, true);
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = 0;
            return newState;
          });
        } else if (isOpen) {
          // Navigate down in dropdown
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.min(prev[index] + 1, filteredPartners.length - 1);
            return newState;
          });
        }
        break;
 
      case 'ArrowUp':
        e.preventDefault();
        if (isOpen) {
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.max(prev[index] - 1, 0);
            return newState;
          });
        }
        break;
 
      case 'Enter':
        e.preventDefault();
        if (isOpen && highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
          const selectedPartner = filteredPartners[highlightedIndex[index]];
          handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          handleDropdownToggle(index, false);
        }
        break;
 
      case 'Escape':
        e.preventDefault();
        if (isOpen) {
          handleDropdownToggle(index, false);
          // Reset search term without applying changes
          setSearchTerm('');
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = -1;
            return newState;
          });
        }
        break;
 
      case 'Tab':
        if (isOpen) {
          // Auto-select highlighted item on Tab (W3C requirement)
          if (highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
            const selectedPartner = filteredPartners[highlightedIndex[index]];
            handlePartnerChange({ target: { value: selectedPartner.id } }, index);
          }
          handleDropdownToggle(index, false);
        }
        break;
 
      default:
        // Allow typing for search functionality
        if (e.key.length === 1) {
          if (!isOpen) {
            handleDropdownToggle(index, true);
          }
        }
        break;
    }
  };
 
  // Enhanced text field keyboard handler
  const handleTextFieldKeyDown = (e: React.KeyboardEvent, index: number) => {
    const filteredPartners = getFilteredPartners(index, searchTerm);
 
    // Add this block before the switch
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      // Focus last MenuItem
      if(filteredPartners.length>0){
              firstMenuItemRefs[index].current?.focus();
            }
      return;
    }
 
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        handleDropdownToggle(index, false);
        setSearchTerm('');
        setHighlightedIndex(prev => {
          const newState = [...prev];
          newState[index] = -1;
          return newState;
        });
        break;
 
  
        case 'Enter':
          e.preventDefault();
          if (highlightedIndex[index] >= 0 && filteredPartners[highlightedIndex[index]]) {
            const selectedPartner = filteredPartners[highlightedIndex[index]];
            handlePartnerChange({ target: { value: selectedPartner.id } }, index);
            handleDropdownToggle(index, false);
          } else if (filteredPartners.length > 0) {
            // Select first item if no item is highlighted
            const selectedPartner = filteredPartners[0];
            handlePartnerChange({ target: { value: selectedPartner.id } }, index);
            handleDropdownToggle(index, false);
          }
          break;
   
        case 'ArrowDown':
          e.preventDefault();
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.min((prev[index] >= 0 ? prev[index] : -1) + 1, filteredPartners.length - 1);
            return newState;
          });
          setTimeout(() => {
            if (filteredPartners.length > 0) {
              firstMenuItemRefs[index].current?.focus();
            }
          }, 100);
          break;
   
        case 'ArrowUp':
          e.preventDefault();
          setHighlightedIndex(prev => {
            const newState = [...prev];
            newState[index] = Math.max(prev[index] - 1, 0);
            return newState;
          });
          break;
         
        default:
          e.stopPropagation();
          break;
      }
    };
   
    // Enhanced menu item hover handler
    const handleMenuItemHover = (partnerIndex: number, index: number) => {
      setHighlightedIndex(prev => {
        const newState = [...prev];
        newState[index] = partnerIndex;
        return newState;
      });
    };
   
    const renderTabletTable = () => {
      return (
        <div
          ref={containerRef}
          className="direct-integration-table-mobile"
          aria-label="Partners Capability Comparison"
          role="table"
        >
          <div
            ref={headerTabRef}
            role="rowgroup"
            style={{
              display: 'grid',
              gridTemplateColumns: '33.33% 33.33% 33.33%'
            }}
          >
            {columnTable.map((header, index) => {
              if (index === 0) return null;
              return (
                <div key={index} className="table-header" role="columnheader">
                  <div className="header-content" role="cell">
                    {index === 0 ? null : selectedPartners[index - 1]
                      .partnerURL ? (
                      compPartner.find(
                        (partner) =>
                          partner.title === selectedPartners[index - 1].partnerURL
                      )?.image?.url ? (
                        <span
                          aria-label={selectedPartners[index - 1].partnerLogo}
                          style={{ display: 'flex', justifyContent: 'center' }}
                        >
                          <img
                            src={
                              getFullImageLink(
                                compPartner.find(
                                  (partner) =>
                                    partner.title ===
                                    selectedPartners[index - 1].partnerURL
                                )?.image?.url
                              )
                            }
                            alt={selectedPartners[index - 1].partnerURL}
                            className="partner-image"
                            aria-hidden="true"
                          />
                        </span>
                      ) : (
                        <span style={{ fontSize: isMobile ? '70%' : '100%' }}>
                          {selectedPartners[index - 1].partnerURL}
                        </span>
                      )
                    ) : (
                      header
                    )}
                  </div>
                  {index > 0 && (
                    <button
                      type="button"
                      className="close-icon"
                      aria-label={`Remove partner ${selectedPartners[index - 1].partnerLogo
                        }`}
                      onClick={() => {
                        const updatedPartners = [...selectedPartners];
                        const partnerToRemove =
                          updatedPartners[index - 1].partnerURL;
                        updatedPartners[index - 1].partnerURL = '';
                        updatedPartners[index - 1].partnerLogo = '';
                        setSelectedPartners(updatedPartners);
                        setResetPartner(partnerToRemove);
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          const updatedPartners = [...selectedPartners];
                          const partnerToRemove =
                            updatedPartners[index - 1].partnerURL;
                          updatedPartners[index - 1].partnerURL = '';
                          updatedPartners[index - 1].partnerLogo = '';
                          setSelectedPartners(updatedPartners);
                          setResetPartner(partnerToRemove);
                        }
                      }}
                    >
                      <img src={CloseIcon} alt="" aria-hidden="true" />
                    </button>
                  )}
                </div>
              );
            })}
            {Array.from({ length: 3 }).map((_, index) => (
              <div className="body-section" role="columnheader" key={index}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  role="cell"
                >
                  <FormControl fullWidth>
                    <div
                      className={`native-select-root ${selectedPartner[index] ? 'has-selection' : ''
                        }`}
                    // tabIndex={0}
                    >
                      <div className="search-select-container">
                        <Select
                          autoComplete="off"
                          variant="standard"
                          inputProps={{
                            'aria-label': `Select partner for column ${index + 1}`
                          }}
                          ref={selectRefs[index]}
                          displayEmpty
                          value={
                            selectedPartners[index].partnerLogo
                              ? handleSelect(index)
                              : ''
                          }
                          onChange={(event) => {
                            if (event.target.value !== undefined) {
                              handlePartnerChange(event, index);
                              handleDropdownToggle(index, false);
                            }
                          }}
                          onKeyDown={(e) => {
                            const allowedKeys = [
                              'ArrowUp',
                              'ArrowDown',
                              'ArrowLeft',
                              'ArrowRight',
                              'Tab',
                              'Enter',
                              'Escape'
                            ];
                            if (!allowedKeys.includes(e.key)) {
                              e.preventDefault();
                            }
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              const target = e.target as HTMLSelectElement;
                              const selectedValue = target.value;
                              handlePartnerChange(
                                { target: { value: selectedValue } },
                                index
                              );
                            }
                          }}
                          open={openDropdown[index]}
                          onClose={() => {
                            handleDropdownToggle(index, false);
                            setSearchTerm('');
                          }}
                          onOpen={() => {
                            handleDropdownToggle(index, true);
                          }}
                          sx={{
                            width: '100%',
                            '.MuiSelect-root .MuiInputBase-root': {
                              width: '100% !important'
                            },
                            // position:'relative'
                            '& .MuiSelect-icon': {
                              display: 'none'
                            },
                            '&:before': {
                              borderBottom: 'none'
                            },
                            '&:after': {
                              borderBottom: 'none'
                            },
                            '&:hover:not(.Mui-disabled):before': {
                              borderBottom: 'none'
                            },
                            '& .MuiSelect-select': {
                              backgroundColor: 'transparent !important'
                            },
                            '& .MuiMenu-list, & .MuiList-padding': {
                              paddingTop: '0px'
                            }
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                  tabIndex={0}
                                >
                                  <img
                                    src={SearchIcon}
                                    alt="search icon"
                                    className="search-icon"
                                    aria-hidden="true"
                                  />
                                  <div
                                    style={{
                                      position: 'relative',
                                      bottom: '-4px',
                                      marginLeft: '10px',
                                      fontWeight: 600,
                                      fontSize: '15px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: isMobile ? '25px' : '100%'
                                    }}
                                  >
                                    Select
                                  </div>
                                </div>
                              );
                            }
                            return (
                              <div
                                style={{ display: 'flex', flexDirection: 'row' }}
                                tabIndex={0}
                              >
                                <img
                                  src={SearchIcon}
                                  alt="search icon"
                                  className="search-icon"
                                  aria-hidden="true"
                                />
                                <div
                                  style={{
                                    position: 'relative',
                                    bottom: '-4px',
                                    marginLeft: '10px',
                                    fontWeight: 600,
                                    fontSize: '15px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: isMobile ? '25px' : '100%'
                                  }}
                                >
                                  {selectedPartners[index].partnerLogo}
                                </div>
                              </div>
                            );
                          }}
                          MenuProps={{
                            // disablePortal: true,
   
                            disableScrollLock: true,
                            anchorOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            PaperProps: {
                              sx: {
                                '&::-webkit-scrollbar': {
                                  display: 'none'
                                },
                                msOverflowStyle: 'none', // IE and Edge
                                scrollbarWidth: 'none', // Firefox
                                '& .MuiMenu-list, & .MuiList-padding': {
                                  paddingTop: '0px',
                                  paddingBottom: '0px'
                                }
                              },
                              style: {
                                maxHeight: 260,
                                overflowY: 'auto',
                                width: '350px',
                                borderRadius: '14px 14px 14px 14px',
                                paddingTop: '0px'
                              }
                            }
                          }}
                        >
                          <div
                            style={{
                              padding: '30px',
                              backgroundColor: '#F1F7FB',
                              borderBottom: '1px solid #1460AA',
                              top: '0px',
                              zIndex: 1,
                              position: 'sticky'
                            }}
                          >
                            <TextField
                              id="input-with-icon-textfield"
                              variant="standard"
                              value={searchTerm}
                              helperText={column[0].helperText_1}
                              aria-label={`Search partner for column ${index + 1
                                }`}
                              inputRef={textFieldRefs[index]}
                              sx={{
                                width: '100%',
                                '& input': {
                                  fontSize: '16px',
                                  fontWeight: 600,
                                  marginBottom: '7px'
                                }
                              }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                  e.preventDefault();
                                  handleDropdownToggle(index, false);
                                }
                                if (e.key === 'Enter' || e.key === 'ArrowDown') {
                                  e.preventDefault();
                                  setTimeout(() => {
                                    firstMenuItemRefs[index].current?.focus();
                                  }, 100); // Wait for dropdown to render
                                } else {
                                  e.stopPropagation();
                                }
                              }}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={SearchIcon}
                                      alt="search icon"
                                      // className="search-icon"
                                      aria-hidden="true"
                                      style={{
                                        width: '25px',
                                        height: '25px',
                                        margin: '0px 10px 10px 0px'
                                      }}
                                    />
                                  </InputAdornment>
                                )
                              }}
                            />
                          </div>
                          {getFilteredPartners(index, searchTerm).map(
                            (partner, partnerIndex) => (
                              <MenuItem
                                className="dropdown-section"
                                key={partnerIndex}
                                value={partner.id}
                                ref={
                                  partnerIndex === 0
                                    ? firstMenuItemRefs[index]
                                    : null
                                }
                                onKeyDown={
                                  partnerIndex === 0
                                    ? (e) => {
                                      if (e.key === 'ArrowUp') {
                                        e.preventDefault();
   
                                        textFieldRefs[index].current?.focus();
                                      }
                                    }
                                    : undefined
                                }
                                tabIndex={-1} // Ensure it's focusable
                                aria-selected={
                                  selectedPartners[index].partnerLogo
                                    ? handleSelect(index) ===
                                    partner.id.toString()
                                    : false
                                }
                                sx={{
                                  height: '50px',
                                  '&.Mui-selected': {
                                    backgroundColor: '#EFF0F2'
                                  }
                                }}
                              >
                                {partner.title}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </div>
                      <div>
                        <img
                          className="arrow-icon"
                          src={ArrowIcon}
                          alt=""
                          aria-hidden="true"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDropdownToggle(index, true)}
                        />
                      </div>
                    </div>
                    <FormHelperText className="custom-helper-text">
                      {selectedPartner[index] ||
                        selectedPartners[index].partnerLogo ? (
                        <span> {column[0].helperText_1} </span>
                      ) : (
                        <span> {column[0].helperText_2} </span>
                      )}
                    </FormHelperText>
                  </FormControl>
                </div>
              </div>
            ))}
          </div>
          <div
            className="collapse-expand"
            style={{
              width: '100%',
              backgroundColor: '#F1F7FB',
              padding: '25px 0px 25px 5px'
            }}
            role="rowgroup"
          >
            <button
              className="expand-collapse-container"
              onClick={toggleExpandCollapse}
              aria-expanded={isExpanded}
              aria-label={isExpanded ? 'Collapse all' : 'Expand all'}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggleExpandCollapse();
                }
              }}
            >
              <span>{isExpanded ? column[0].collapse : column[0].expand}</span>
              <img
                src={ChevronDown}
                alt={isExpanded ? 'Collapse all' : 'Expand all'}
                className="arrow-icon"
                aria-hidden="true"
              />
            </button>
          </div>
          <div role="rowgroup">
            {section.map((functionality, functionalityIndex) => (
              <Fragment key={functionalityIndex}>
                {/* Functionality Level Accordion */}
                <div className="custom-subsection" role="rowgroup">
                  <div role="row">
                    <Accordion
                      role="button"
                      key={functionalityIndex}
                      expanded={expandedFunctionalities[functionalityIndex] || false}
                      onChange={() => handleFunctionalityToggle(functionalityIndex)}
                      aria-controls={`functionality-${functionalityIndex}-content`}
                      id={`functionality-${functionalityIndex}-header`}
                      aria-expanded={expandedFunctionalities[functionalityIndex] || false}
                      sx={{
                        backgroundColor: '#f1f7fa',
                        borderBottom: 'none',
                        boxShadow: 'none',
                        '&.Mui-expanded': {
                          padding: 0,
                          margin: 0
                        }
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <img
                            src={DownArrow}
                            alt="Expand functionality"
                            className="custom-accordion-icon"
                          />
                        }
                        aria-label={`${functionality.id} - ${functionality.title} Section`}
                        aria-controls={`functionality-${functionalityIndex}-content`}
                        id={`functionality-${functionalityIndex}-header`}
                        aria-expanded={expandedFunctionalities[functionalityIndex] || false}
                        sx={{
                          padding: '0 16px',
                          height: '56px',
                          pr: 2,
                          backgroundColor: '#ddecf5',
                          fontWeight: 'bold',
                          fontSize: '16px',
                          '&.Mui-expanded': {
                            borderBottom: '1px solid #C9CACC'
                          }
                        }}
                      >
                        <span className="">
                          {functionality.title}
                        </span>
                      </AccordionSummary>
                      <AccordionDetails style={{ padding: 0 }}>
                        {/* Feature Level - Conditional Accordion or Content */}
                        {functionality.features?.map((feature, featureIndex) => (
                          <div key={featureIndex} className="subsection-table" role="rowgroup" style={{ margin: '0', background: '#f9f9f9' }}>
                            <div role="row">
                              <div
                                className={`subsection-tr-section ${expandedFeatures[`${functionalityIndex}-${featureIndex}`] ? ' expanded' : ''}`}
                                onClick={() => handleFeatureToggle(functionalityIndex, featureIndex)}
                              >
                                <div
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: feature.subFeatures && feature.subFeatures.length > 0 ? '85% 15%' : '100%'
                                  }}
                                  role="rowheader"
                                >
                                  <div className="description-section">{feature.title}</div>
                                  {/* Expand/collapse icon for features with subFeatures */}
                                  {feature.subFeatures && feature.subFeatures.length > 0 && (
                                    <span
                                      style={{ marginLeft: 8, display: 'inline-flex', alignItems: 'center', justifySelf: 'end', marginRight: 20 }}
                                      aria-label={expandedFeatures[`${functionalityIndex}-${featureIndex}`] ? `Collapse ${feature.title}` : `Expand ${feature.title}`}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <img
                                        src={DownArrow}
                                        alt={expandedFeatures[`${functionalityIndex}-${featureIndex}`] ? `Collapse ${feature.title}` : `Expand ${feature.title}`}
                                        className="custom-accordion-icon"
                                        style={{ transform: expandedFeatures[`${functionalityIndex}-${featureIndex}`] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                                      />
                                    </span>
                                  )}
                                </div>
                                <div
                                  style={{
                                    display: 'grid',
                                    gridTemplateColumns: '33.33% 33.33% 33.33%',
                                    alignItems: 'center'
                                  }}
                                  role="row"
                                >
                                  {Array.from({ length: 3 }).map((_, index) => (
                                    <div
                                      role="cell"
                                      className="icon-section"
                                      key={index}
                                    >
                                      <div className="yes-with-arrow">
                                        <span className="description-status-icon">
                                          {getStatusIcon(
                                            calculateAverageStatus([feature], selectedPartner, index)
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                            {/* Subfeatures, if any, as a separate block below */}
                            {feature.subFeatures && feature.subFeatures.length > 0 && expandedFeatures[`${functionalityIndex}-${featureIndex}`] && (
                              <div className="subsection-table" role="rowgroup">
                                {feature.subFeatures.map((subFeature, subIndex) => (
                                  <Fragment key={subIndex}>
                                    <div role="row">
                                      <div
                                        className={`subsection-tr-section no-border-bottom`}
                                        style={{ background: '#fff' }}
                                      >
                                        <div
                                          style={{
                                            display: 'grid',
                                            gridTemplateColumns: '90% 10%'
                                          }}
                                          role="rowheader"
                                        >
                                          <div
                                            className={`description-section no-border-bottom`}
                                          >
                                            {subFeature.title}
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            display: 'grid',
                                            gridTemplateColumns: '33.33% 33.33% 33.33%',
                                            alignItems: 'center'
                                          }}
                                          role="row"
                                        >
                                          {Array.from({ length: 3 }).map((_, index) => {
                                            const status = subFeature.partners?.[
                                              selectedPartners[index]?.partnerLogo ??
                                              selectedPartner[index]
                                            ];
                                            return (
                                              <div
                                                role="cell"
                                                className={`icon-section no-border-bottom`}
                                                key={index}
                                              >
                                                <div className="yes-with-arrow">
                                                  <span className="description-status-icon">
                                                    {status && getStatusIcon(status)}
                                                  </span>
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </Fragment>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </Fragment>
            ))}
          </div>
        </div>
      );
    };
   
   
    const renderDesktopTable = () => {
      return (
        <table
          ref={containerRef}
          className="direct-integration-table"
          aria-label="Partners Capability Comparison"
        >
          <thead ref={headerRef} className='table-thead'>
            <tr>
              <th className="s-only" scope="col" style={{ width: '576px' }}
              ><span>
                  {columnTable[0]}
                </span>
              </th>
              {Array.from({ length: 3 }).map((_, index) => (
                <th className="s-only" key={index} scope="col" style={{ textAlign: 'center' }}>
                  <span>
                    {selectedPartners[index].partnerLogo || `Partner ${index + 1}`}
                  </span>
                </th>
              ))}
            </tr>
            <tr>
              {columnTable.map((header, index) => {
                return (
                  <td key={index}
                    className="table-header"
                  >
                    <div className="header-content">
                      {index === 0 ? (
                        <span aria-hidden="true">{header}</span>
                      ) : (
                        <span aria-hidden="true">
                          {selectedPartners[index - 1].partnerURL ? (
                            compPartner.find(
                              (partner) => partner.title === selectedPartners[index - 1].partnerURL
                            )?.image?.url ? (
                              <img
                                src={
                                  getFullImageLink(
                                    compPartner.find(
                                      (partner) =>
                                        partner.title === selectedPartners[index - 1].partnerURL
                                    )?.image?.url
                                  )
                                }
                                alt={selectedPartners[index - 1].partnerURL}
                                aria-hidden="true"
                                className="partner-image"
                              />
                            ) : (
                              <span>{selectedPartners[index - 1].partnerURL}</span>
                            )
                          ) : (
                            header
                          )}
                        </span>
                      )}
                      {index > 0 && (
                        <button
                          type="button"
                          className="close-icon"
                          aria-label={`Remove ${selectedPartners[index - 1].partnerLogo || selectedPartners[index - 1].partnerURL || `Partner ${index}`}`}
                          onClick={() => {
                            const updatedPartners = [...selectedPartners];
                            const partnerToRemove = updatedPartners[index - 1].partnerURL
                            updatedPartners[index - 1].partnerURL = '';
                            updatedPartners[index - 1].partnerLogo = '';
                            setSelectedPartners(updatedPartners);
                            setResetPartner(partnerToRemove);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              const updatedPartners = [...selectedPartners];
                              const partnerToRemove = updatedPartners[index - 1].partnerURL
                              updatedPartners[index - 1].partnerURL = '';
                              updatedPartners[index - 1].partnerLogo = '';
                              setSelectedPartners(updatedPartners);
                              setResetPartner(partnerToRemove);
                            }
                          }}
                        >
                          <img
                            src={CloseIcon}
                            alt=""
                            aria-hidden="true"
                          />
                        </button>
                      )
                      }
                    </div>
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
          <>
            <tr>
              <th className="body-section body-row" scope="col">
                <div className="collapse-expand">
                  <h4 style={{ margin: 0, fontWeight: 'unset' }}>
                    <button
                      className="expand-collapse-container"
                      onClick={toggleExpandCollapse}
                      aria-expanded={isExpanded}
                      aria-label={isExpanded ? 'Collapse all' : 'Expand all'}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          toggleExpandCollapse();
                        }
                      }}
                    >
                      <span>
                        {isExpanded ? column[0].collapse : column[0].expand}
                      </span>
                      <img
                        src={ChevronDown}
                        alt={isExpanded ? 'Collapse all' : 'Expand all'}
                        className="arrow-icon"
                        aria-hidden="true"
                      />
                    </button>
                  </h4>
                </div>
              </th>
              {Array.from({ length: 3 }).map((_, index) => (
                <td className="body-section">
                  <FormControl fullWidth>
                    <div
                      className={`native-select-root ${selectedPartner[index] ? 'has-selection' : ''}`}
                    >
                      <div className="search-select-container">
                        <Select
                          autoComplete="off"
                          variant="standard"
                          SelectDisplayProps={{
                            'aria-label': selectedPartners[index].partnerLogo
                              ? `Change partner: ${selectedPartners[index].partnerLogo}`
                              : `Select partner for column ${index + 1}`,
                            role: 'button',
                            'aria-haspopup': 'dialog'
                          }}
                          ref={selectRefs[index]}
                          displayEmpty
                          value={
                            selectedPartners[index].partnerLogo
                              ? handleSelect(index)
                              : ''
                          }
                          onChange={(event) => {
                            if (event.target.value !== undefined) {
                              handlePartnerChange(event, index);
                              handleDropdownToggle(index, false);
                            }
                          }}
                          onKeyDown={(e) => handleSelectKeyDown(e, index)}
                          open={openDropdown[index]}
                          onClose={() => {
                            handleDropdownToggle(index, false);
                            setSearchTerm('');
                            setHighlightedIndex(prev => {
                              const newState = [...prev];
                              newState[index] = -1;
                              return newState;
                            });
                          }}
                          onOpen={() => {
                            handleDropdownToggle(index, true);
                            setHighlightedIndex(prev => {
                              const newState = [...prev];
                              newState[index] = -1;
                              return newState;
                            });
                          }}
                          sx={{
                            width: '100%',
                            '.MuiSelect-root .MuiInputBase-root': {
                              width: '100% !important'
                            },
                            // position:'relative'
                            '& .MuiSelect-icon': {
                              display: 'none'
                            },
                            '&:before': {
                              borderBottom: 'none'
                            },
                            '&:after': {
                              borderBottom: 'none'
                            },
                            '&:hover:not(.Mui-disabled):before': {
                              borderBottom: 'none'
                            },
                            '& .MuiSelect-select': {
                              backgroundColor: 'transparent !important'
                            },
                            '& .MuiMenu-list, & .MuiList-padding': {
                              paddingTop: '0px'
                            }
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row'
                                  }}
                                  tabIndex={0}
                                >
                                  <img
                                    src={SearchIcon}
                                    alt="search icon"
                                    className="search-icon"
                                    aria-hidden="true"
                                  />
                                  <div
                                    style={{
                                      position: 'relative',
                                      bottom: '-4px',
                                      marginLeft: '10px',
                                      fontWeight: 600,
                                      fontSize: '15px',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      width: isMobile ? '25px' : '100%'
                                    }}
                                  >
                                    {column[0].dropdownText}
                                  </div>
                                </div>
                              );
                            }
                            return (
                              <div
                                style={{ display: 'flex', flexDirection: 'row' }}
                              // tabIndex={0}
                              >
                                <img
                                  src={SearchIcon}
                                  alt="search icon"
                                  className="search-icon"
                                  aria-hidden="true"
                                />
                                <div
                                  style={{
                                    position: 'relative',
                                    bottom: '-4px',
                                    marginLeft: '10px',
                                    fontWeight: 600,
                                    fontSize: '15px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    width: isMobile ? '25px' : '100%'
                                  }}
                                >
                                  {selectedPartners[index].partnerLogo.length > 12
                                    ? `${selectedPartners[index].partnerLogo.substring(0, 12)}...`
                                    : selectedPartners[index].partnerLogo}
                                </div>
                              </div>
                            );
                          }}
                          MenuProps={{
                            // disablePortal: true,
 
                            disableScrollLock: true,
                            anchorOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            transformOrigin: {
                              vertical: 'top',
                              horizontal: 'left'
                            },
                            PaperProps: {
                              sx: {
                                '&::-webkit-scrollbar': {
                                  display: 'none'
                                },
                                msOverflowStyle: 'none', // IE and Edge
                                scrollbarWidth: 'none', // Firefox
                                '& .MuiMenu-list, & .MuiList-padding': {
                                  paddingTop: '0px',
                                  paddingBottom: '0px'
                                }
                              },
                              style: {
                                maxHeight: 260,
                                overflowY: 'auto',
                                width: '350px',
                                borderRadius: '14px 14px 14px 14px',
                                paddingTop: '0px',
                                marginTop: '-21px',
                                marginLeft: '-17px'
                              },
                              //ref: dropdownDialogRefs[index],
                              role: 'dialog',
                              'aria-modal': 'true',
                              'aria-label': selectedPartners[index].partnerLogo
                                ? `Change partner: ${selectedPartners[index].partnerLogo}`
                                : `Select partner for column ${index + 1}`
                            }
                          }}
                        >
                          <div
                            style={{
                              padding: '30px',
                              backgroundColor: '#F1F7FB',
                              borderBottom: '1px solid #1460AA',
                              top: '0px',
                              zIndex: 1,
                              position: 'sticky'
                            }}
                          >
                            <TextField
                              id="input-with-icon-textfield"
                              variant="standard"
                              value={searchTerm}
                              helperText={column[0].helperText_1}
                              inputRef={textFieldRefs[index]}
                              autoFocus
                              inputProps={{
                                'aria-label': `Search partner for column ${index + 1}`,
                                'aria-autocomplete': 'list',
                                'aria-controls': `partner-suggestion-list-${index}`
                              }}
                              sx={{
                                width: '100%',
                                '& input': {
                                  fontSize: '16px',
                                  fontWeight: 600,
                                  marginBottom: '7px'
                                }
                              }}
                              onChange={(e) => setSearchTerm(e.target.value)}
                              onKeyDown={(e) => handleTextFieldKeyDown(e, index)}
                              InputProps={{
                                startAdornment: (
                                  <InputAdornment position="start">
                                    <img
                                      src={SearchIcon}
                                      alt="search icon"
                                      // className="search-icon"
                                      aria-hidden="true"
                                      style={{
                                        width: '25px',
                                        height: '25px',
                                        margin: '0px 10px 10px 0px'
                                      }}
                                    />
                                  </InputAdornment>
                                )
                              }}
                            />
                          </div>
                          {getFilteredPartners(index, searchTerm).map(
                            (partner, partnerIndex, arr) => (
                              <MenuItem
                                className="dropdown-section"
                                key={partnerIndex}
                                value={partner.id}
                                role="option"
                                aria-label={partner.title}
                                id={`partner-option-${index}-${partnerIndex}`}
                                ref={
                                  partnerIndex === 0
                                    ? firstMenuItemRefs[index]
                                    : null
                                }
                                onKeyDown={(e) => {
                                  if (partnerIndex === 0 && e.key === 'ArrowUp') {
                                    e.preventDefault();
                                    textFieldRefs[index].current?.focus();
                                  }
                                  else if(e.key === 'Tab'){
                                    e.preventDefault();
                                    e.stopPropagation();
                                    textFieldRefs[index].current?.focus();
                                  }
                                  else if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handlePartnerChange({ target: { value: partner.id } }, index);
                                    handleDropdownToggle(index, false);
                                  }
 
                                }
                                }
                                onMouseEnter={() => handleMenuItemHover(partnerIndex, index)}
                                tabIndex={0} // Ensure it's focusable
                                aria-selected={
                                  selectedPartners[index].partnerLogo
                                    ? handleSelect(index) ===
                                    partner.id.toString()
                                    : false
                                }
                                sx={{
                                  height: '50px',
                                  '&.Mui-selected': {
                                    backgroundColor: '#EFF0F2'
                                  }
                                }}
                              >
                                {partner.title}
                              </MenuItem>
                            )
                          )}
                        </Select>
                      </div>
                      <div>
                        <img
                          className="arrow-icon"
                          src={ArrowIcon}
                          alt=""
                          aria-hidden="true"
                          style={{ cursor: 'pointer' }}
                          onClick={() => handleDropdownToggle(index, true)}
                        />
                      </div>
                    </div>
                    <FormHelperText className="custom-helper-text">
                      {selectedPartner[index] ||
                        selectedPartners[index].partnerLogo ? (
                        <span> {column[0].helperText_1} </span>
                      ) : (
                        <span> {column[0].helperText_2} </span>
                      )}
                    </FormHelperText>
                  </FormControl>
                </td>
              ))}
            </tr>
            {section.map((functionality, sectionIndex) => (
              <Fragment key={sectionIndex}>
                <tr style={{ height: '72px' }}>
                  <td className="custom-subsection" colSpan={columnTable.length}>
                    <h5 style={{
                      margin: 0,
                      fontWeight: 'unset',
                    }}>
                      <Accordion
                        expanded={expandedFunctionalities[sectionIndex] || false}
                        onChange={() => handleFunctionalityToggle(sectionIndex)}
                        aria-controls={`panel-func-${sectionIndex}-content`}
                        id={`panel-func-${sectionIndex}-header`}
                        aria-expanded={expandedFunctionalities[sectionIndex] || false}
                        sx={{
                          backgroundColor: expandedFunctionalities[sectionIndex] ? '#ddecf5' : '#f1f7fa',
                          boxShadow: 'none',
                          '&.Mui-expanded': {
                            padding: 0,
                            margin: 0,
                          },
                        }}
                      >
                        <AccordionSummary
                          expandIcon={
                            <img
                              src={DownArrow}
                              alt={`Expand ${functionality.title}`}
                              className="custom-accordion-icon"
                            />
                          }
                          aria-controls={`panel-func-${sectionIndex}-content`}
                          id={`panel-func-${sectionIndex}-header`}
                          aria-expanded={expandedFunctionalities[sectionIndex] || false}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: 0,
                            height: '72px',
                            pr: 2
                          }}
                        >
                          <span className="subsection-text" style={{ fontWeight: 'bold', fontSize: '16px' }}>
                            {functionality.title}
                          </span>
                        </AccordionSummary>
                      </Accordion>
                    </h5>
                  </td>
                </tr>
                {expandedFunctionalities[sectionIndex] &&
                  functionality.features.map((feature, featureIndex) => (
                    <Fragment key={featureIndex}>
                      {feature.subFeatures ? (
                        // Feature has subFeatures - render as accordion
                        <Fragment>
                          <tr
                            className="subsection-tr-section"
                            style={{
                              height: '72px',
                              borderBottom: 'none'
                            }}
                            onClick={() => handleFeatureToggle(sectionIndex, featureIndex)}
                            onKeyDown={e => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleFeatureToggle(sectionIndex, featureIndex);
                              }
                            }}
                          >
                            <th scope='row' className={`description-section ${expandedFeatures[`${sectionIndex}-${featureIndex}`] ? ' expanded' : ''}`} >
                              {feature.title}
                            </th>
                            {Array.from({ length: 3 }).map((_, index) => {
                              const status = calculateAverageStatus(feature.subFeatures, selectedPartner, index);
                              // Place expand/collapse icon only in the last cell
                              if (index === 2) {
                                return (
                                  <td className={`icon-section ${expandedFeatures[`${sectionIndex}-${featureIndex}`] ? ' expanded' : ''}`} key={index} style={{ paddingRight: 16 }}>
                                    <div className="yes-with-arrow" >
                                      <span className="description-status-icon">{status && getStatusIcon(status)}</span>
                                      <span
                                        className='arrow-container'
                                        style={{ marginLeft: 8, display: 'inline-flex', alignItems: 'center', justifySelf: 'end', cursor: 'pointer' }}
                                        aria-label={expandedFeatures[`${sectionIndex}-${featureIndex}`] ? `Collapse ${feature.title}` : `Expand ${feature.title}`}
                                        role="button"
                                        tabIndex={0}
                                      >
                                        <img
                                          src={DownArrow}
                                          alt={expandedFeatures[`${sectionIndex}-${featureIndex}`] ? `Collapse ${feature.title}` : `Expand ${feature.title}`}
                                          className="custom-accordion-icon"
                                          style={{ transform: expandedFeatures[`${sectionIndex}-${featureIndex}`] ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                                        />
                                      </span>
                                    </div>
                                  </td>
                                );
                              } else {
                                return (
                                  <td className={`icon-section ${expandedFeatures[`${sectionIndex}-${featureIndex}`] ? ' expanded' : ''}`} key={index} style={{}}>
                                    <div className="yes-with-arrow">
                                      <span className="description-status-icon">{status && getStatusIcon(status)}</span>
                                    </div>
                                  </td>
                                );
                              }
                            })}
                          </tr>
                          {expandedFeatures[`${sectionIndex}-${featureIndex}`] &&
                            feature.subFeatures.map((subFeature, descIndex) => (
                              <Fragment key={descIndex}>
                                <tr className="subsection-tr-section" style={{ borderBottom: 'none', backgroundColor: 'transparent' }}>
                                  <th scope='row' className="description-section" style={{ borderBottom: 'none', backgroundColor: 'transparent' }}>
                                    {subFeature.title}
                                  </th>
                                  {Array.from({ length: 3 }).map((_, index) => {
                                    const status = subFeature.partners?.[selectedPartners[index]?.partnerLogo ??
                                      selectedPartner[index]];
                                    return (
                                      <td className="icon-section" key={index} style={{ borderBottom: 'none', backgroundColor: 'transparent' }}>
                                        <div className="yes-with-arrow">
                                          <span className="description-status-icon">{status && getStatusIcon(status)}</span>
                                        </div>
                                      </td>
                                    );
                                  })}
                                </tr>
                              </Fragment>
                            ))
                          }
                        </Fragment>
                      ) : (
                        // Feature has no subFeatures - render as plain content
                        <tr className="subsection-tr-section" style={{ borderBottom: '1px solid #C9CACC' }}>
                          <th scope='row' className="description-section" style={{   }}>
                            {feature.title}
                          </th>
                          {Array.from({ length: 3 }).map((_, index) => {
                            const status = feature.partners?.[selectedPartners[index]?.partnerLogo ??
                              selectedPartner[index]];
                            return (
                              <td className="icon-section" key={index} style={{  }}>
                                <div className="yes-with-arrow">
                                  <span className="description-status-icon">{status && getStatusIcon(status)}</span>
                                </div>
                              </td>
                            );
                          })}
                        </tr>
                      )}
                    </Fragment>
                  ))
                }
              </Fragment>
            ))}
          </>
        </tbody>
      </table>
    );
  };
 
  const renderFooter = () => {
    const footerData = column[0].footer[0].entries;
    const roadMapLink = column[0].footer[1].links[0];
    return (
      <div className="infoAndLinksBar">
        <div className="footer-status-icons">
          {footerData.map((item, index) => {
            return (
              <div key={index} className="footer-status-item">
                <span className="footer-status-icon" aria-hidden="true">
                  {getStatusIcon(item.text)}
                </span>
                <span aria-label={item.text} className="footer-status-text">
                  {item.text}
                </span>
              </div>
            );
          })}
          <div className="footer-roadmap-link">
            <p>
              {column[0].footer[0].text_1} {''}
              <a href={`/${i18n.language}/api/${roadMapLink.path}`}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Roadmap link: ${roadMapLink.text}`}
              >
                {roadMapLink.text}
              </a> {''}
              {column[0].footer[0].text_2} {''}
            </p>
          </div>
        </div>
      </div>
    );
  };
 
  // const renderMobileTable = () => {
  //   return (
  //     <div className="direct-integration-table-mobile">
  //       {sections.map((section, sectionIndex) => {
  //         return (
  //           <Fragment key={sectionIndex}>
  //             <div className="container-header">{section.title}</div>
  //             {section.subsections.map((subsection, subsectionIndex) => {
  //               return (
  //                 <Fragment key={`${sectionIndex}-${subsectionIndex}`}>
  //                   <div className="container-subheader">
  //                     {subsection.title}
  //                   </div>
  //                   {subsection.features.map((feature, featureIndex) => {
  //                     return (
  //                       <div
  //                         className="subsection"
  //                         key={`${sectionIndex}-${subsectionIndex}-${featureIndex}`}
  //                       >
  //                         {columns.slice(1).map((column, columnIndex) => {
  //                           return (
  //                             <div
  //                               className="feature"
  //                               key={`${sectionIndex}-${subsectionIndex}-${featureIndex}-${columnIndex}`}
  //                             >
  //                               <p className="feature-header">{column}</p>
  //                               {columnIndex === 0
  //                                 ? feature.description
  //                                 : columnIndex === 1
  //                                   ? feature.air_canada_ndc_api
  //                                   : feature.gds_edifact}
  //                             </div>
  //                           );
  //                         })}
  //                       </div>
  //                     );
  //                   })}
  //                 </Fragment>
  //               );
  //             })}
  //           </Fragment>
  //         );
  //       })}
  //     </div>
  //   );
  // };
 
  const renderPopup = () => {
    if (!isInfoBoxOpen) return null;
    const popupContent = column[0].popUp_box;
    return (
      <div
        className={`info-popup ${language === 'fr' ? 'fr' : ''}`}
        role="dialog"
        aria-labelledby="popup-heading"
        aria-describedby="popup-paragraph"
        aria-modal="true"
        onMouseEnter={() => setIsInfoBoxOpen(true)}
        onMouseLeave={() => setIsInfoBoxOpen(false)}
      >
        <div className="popup-content">
          <h4
            id="popup-heading"
            style={{
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '20px',
              letterSpacing: '0px',
              color: '#000000'
            }}
          >
            {popupContent.heading}
          </h4>
          <p
            id="popup-paragraph"
            dangerouslySetInnerHTML={{ __html: popupContent.paragraph }}
          />
        </div>
        <div className="popup-close">
          <IconButton
            onClick={toggleCloseInfoBox}
            aria-label="Close popup"
            className="close-icon"
          >
            <img src={CloseIcon} alt="" aria-hidden="true" />
          </IconButton>
        </div>
      </div>
    );
  };
 
  const handleResetToDefault = () => {
    setResetPartner('reset');
    announceTableUpdate();
  };
 
  useEffect(() => {
    if (resetPartner === 'reset') {
      setResetPartner(null);
    }
  }, [resetPartner]);
 
  return (
    <div className="connection-options-body-content">
      <PartnerSelection
        partner={compPartner}
        onPartnerChange={handlePartnerSelection}
        resetPartner={resetPartner}
        parentSelectedPartners={selectedPartners}
      />
      <div
        aria-live="polite"
        aria-atomic="true"
        style={{
          position: 'absolute',
          left: '-9999px',
          height: '1px',
          width: '1px',
          overflow: 'hidden'
        }}
      >
        {announcementMessage}
      </div>
      <div
        className="content-spacing"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'end' : 'center',
          gap: isMobile ? '10px' : '40px'
        }}
        role="toolbar"
        aria-label="Table actions"
      >
        {/* <Button
          className="top-content"
          aria-label={column[0].download}
          onClick={() => console.log('Download icon clicked')}
          // aria-label={column[0].download}
          // aria-hidden="true"
          // className="download-icon"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              console.log('Download icon clicked');
            }
          }}
        >
          <img
            src={DownloadIcon}
            alt=""
            aria-hidden="true"
            style={{ marginRight: '8px' }}
          />
 
          <span
            className="download-text"
            style={{
              color: '#1460AA',
              fontWeight: '700',
              fontSize: '16px',
              lineHeight: '20px',
              letterSpacing: '0px',
              textTransform: 'none'
            }}
          >
            {column[0].download}
          </span>
          <IconButton
            // onClick={toggleInfoBox}
            aria-label="More information"
            className="info-icon"
            style={{ color: '#717173' }}
            onMouseEnter={() => setIsInfoBoxOpen(true)}
            onMouseLeave={() => setIsInfoBoxOpen(false)}
          >
            <img src={InfoIcon} alt="" aria-hidden="true" />
          </IconButton>
        </Button> */}
       <Button
          variant='secondary'
          size='md'
          onClick={handleResetToDefault}
          aria-label={column[0].reset}
          sx={{
            '@media(max-width: 600px)': {
              width: '100%',
              maxWidth:'initial'
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleResetToDefault();
            }
          }}
        >
          <span>{column[0].reset}</span>
        </Button>
      </div>
      {renderPopup()}
      {/* {renderDesktopTable()} */}
      {/* <h3>{data[0].title}</h3> */}
      {isTablet ? renderTabletTable() : renderDesktopTable()}
      {renderFooter()}
    </div>
  );
};
 
export default DirectIntegrationTable;
 
 